package com.mgacreative.hotel.feature.staff.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.domain.model.Shift
import com.mgacreative.hotel.domain.model.Staff
import com.mgacreative.hotel.domain.repository.ShiftRepository
import com.mgacreative.hotel.domain.repository.StaffRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn

class ShiftPlannerViewModel(
    private val shiftRepository: ShiftRepository,
    private val staffRepository: StaffRepository
) : ViewModel() {

    private val _currentDate = MutableStateFlow(Clock.System.todayIn(TimeZone.currentSystemDefault()))
    val currentDate: StateFlow<LocalDate> = _currentDate.asStateFlow()

    private val _shifts = MutableStateFlow<List<Shift>>(emptyList())
    val shifts: StateFlow<List<Shift>> = _shifts.asStateFlow()

    private val _staffList = MutableStateFlow<List<Staff>>(emptyList())
    val staffList: StateFlow<List<Staff>> = _staffList.asStateFlow()

    init {
        viewModelScope.launch {
            shiftRepository.shifts.collect { _shifts.value = it }
        }
        viewModelScope.launch {
            staffRepository.staffList.collect { _staffList.value = it }
        }
        
        loadData()
    }

    private fun loadData() {
        viewModelScope.launch {
            staffRepository.loadStaff()
            shiftRepository.loadShiftsForDate(_currentDate.value.toString())
        }
    }

    fun nextDay() {
        _currentDate.value = _currentDate.value.plus(1, DateTimeUnit.DAY)
        loadData()
    }

    fun previousDay() {
        _currentDate.value = _currentDate.value.minus(1, DateTimeUnit.DAY)
        loadData()
    }

    fun addShift(staffId: String, startTime: String, endTime: String, role: String) {
        viewModelScope.launch {
            val shift = Shift(
                staff_id = staffId,
                date = _currentDate.value.toString(),
                start_time = startTime,
                end_time = endTime,
                role = role,
                status = "SCHEDULED"
            )
            val success = shiftRepository.addShift(shift)
            if (success) {
                shiftRepository.loadShiftsForDate(_currentDate.value.toString())
            }
        }
    }
}
